var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SearchResultsContext } from "@/contexts";
import { isJobDatePostedValue } from "@/types/SearchData";
import { SearchParamType } from "@/types/SearchParamType";
import { Box, Button, Field, useSlotRecipe, VStack } from "@chakra-ui/react";
import { useContext } from "react";
import { useSearchParams } from "react-router-dom";
import { CountryDropdown } from "@/components/SearchForm/CountryDropdown";
import { LocationAutocompleteInput, QueryAutocompleteInput, CompanyAutocompleteInput, } from "@/components/cortex";
import { SearchFormContext } from "@/components/cortex/components/SearchForm/SearchFormContext";
import { DatePostedFilter } from "./DatePostedFilter";
import { JobCategoryMultiSelect } from "./JobCategoryMultiSelect";
import { JobTypeMultiSelect } from "./JobTypeMultiSelect";
import { RemoteOnlyToggle } from "./RemoteOnlyToggle";
export function SearchFormChildren(_a) {
    var _b;
    var modules = _a.modules, datePostedOptions = _a.datePostedOptions;
    var recipe = useSlotRecipe({ key: "SearchFormChildren" });
    var recipeProps = recipe.splitVariantProps({})[0];
    var styles = recipe(recipeProps);
    var searchParams = useSearchParams()[0];
    var selectedDatePosted = searchParams.get(SearchParamType.DATE_POSTED);
    var hasDatePostedSelection = selectedDatePosted !== null;
    var hasSupportedDatePostedOption = datePostedOptions === null || datePostedOptions === void 0 ? void 0 : datePostedOptions.some(function (option) {
        return isJobDatePostedValue(option.value);
    });
    var isDatePostedUnavailable = datePostedOptions !== undefined &&
        selectedDatePosted !== null &&
        !datePostedOptions.some(function (option) {
            return isJobDatePostedValue(option.value) &&
                option.value === selectedDatePosted;
        });
    var _c = useContext(SearchResultsContext), searchData = _c.searchData, filterOptionsLoading = _c.filterOptionsLoading;
    var jobTypeSuidValues = useContext(SearchFormContext).jobTypeSuidValues;
    var showJobTypeFilter = modules.jobTypeFilter === true &&
        (filterOptionsLoading ||
            jobTypeSuidValues.length > 0 ||
            ((_b = searchData === null || searchData === void 0 ? void 0 : searchData.filterOptions.jobTypes.length) !== null && _b !== void 0 ? _b : 0) > 0);
    return (_jsxs(VStack, { children: [_jsxs(Box, __assign({ css: [styles.container, styles.searchContainer] }, { children: [_jsx(Field.Root, __assign({ css: styles.what }, { children: _jsx(QueryAutocompleteInput, {}) })), _jsx(Field.Root, __assign({ css: styles.where }, { children: _jsx(LocationAutocompleteInput, {}) })), _jsx(Field.Root, __assign({ css: styles.submit }, { children: _jsx(Button, __assign({ css: styles.search, type: "submit", name: "search" }, { children: "Find Jobs" })) }))] })), (modules.countryDropdown ||
                modules.remoteOnlyToggle ||
                modules.companyFilter ||
                modules.occupationsFilter ||
                showJobTypeFilter ||
                (modules.datePostedFilter &&
                    (hasDatePostedSelection || hasSupportedDatePostedOption))) && (_jsxs(Box, __assign({ css: [styles.container, styles.filterContainer] }, { children: [modules.countryDropdown && (_jsx(Field.Root, __assign({ css: styles.countryDropdown }, { children: _jsx(CountryDropdown, {}) }))), modules.remoteOnlyToggle && (_jsx(Field.Root, __assign({ css: styles.remoteOnlyToggle }, { children: _jsx(RemoteOnlyToggle, {}) }))), modules.companyFilter && (_jsx(Field.Root, __assign({ css: styles.filter }, { children: _jsx(CompanyAutocompleteInput, {}) }))), modules.occupationsFilter && (_jsx(Field.Root, __assign({ css: styles.jobCategoryFilter }, { children: _jsx(JobCategoryMultiSelect, {}) }))), modules.datePostedFilter &&
                        (hasDatePostedSelection || hasSupportedDatePostedOption) && (_jsx(Field.Root, __assign({ css: __spreadArray([
                            styles.dateFilter
                        ], (isDatePostedUnavailable
                            ? [styles.unavailableDateFilter]
                            : []), true) }, { children: _jsx(DatePostedFilter, { options: datePostedOptions }) }))), showJobTypeFilter && (_jsx(Field.Root, __assign({ css: styles.jobTypeFilter }, { children: _jsx(JobTypeMultiSelect, {}) })))] })))] }));
}
